module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"personalAccountSetting":"My account settings","systemSetting":"System settings","logout":"Logout"},"ja":{"personalAccountSetting":"個人アカウント設定","systemSetting":"システム設定","logout":"ログアウト"},"zh-hant":{"personalAccountSetting":"個人賬戶設置","systemSetting":"系統設置","logout":"註銷"},"zh-hans":{"personalAccountSetting":"个人账户设置","systemSetting":"系统设置","logout":"注销"}}')
  delete Component.options._Ctor
}
